import { BookmarkBorderOutlined, Bookmark } from "@mui/icons-material";
import { doc, setDoc, deleteDoc, onSnapshot, serverTimestamp } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../utils/firebase";
import toasted from "../../config/toasted";

const Bookmarks = ({ userData, visibleData }) => {
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [loading, setLoading] = useState(false);

  const promptId = visibleData?.id;
  const userId = userData?.uid;

  const bookmarkId = userId && promptId ? `${userId}_${promptId}` : null;

  useEffect(() => {
    if (!bookmarkId) return;

    const ref = doc(db, "bookmarks", bookmarkId);

    const unsubscribe = onSnapshot(ref, (snap) => {
      setIsBookmarked(snap.exists());
    });

    return () => unsubscribe();
  }, [bookmarkId]);

  const handleToggle = async () => {
    if (!userId) {
      toasted.error("Login required");
      return;
    }

    if (!bookmarkId) return;

    try {
      setLoading(true);

      const ref = doc(db, "bookmarks", bookmarkId);

      if (isBookmarked) {
        await deleteDoc(ref);
        toasted.success("Bookmark removed");
      } else {
        await setDoc(ref, {
          userId,
          promptId,
          title: visibleData?.title || "",
          category: visibleData?.category || "",
          createdAt: serverTimestamp(),
        });
        toasted.success("⛉ Bookmark saved");
      }
    } catch (error) {
      console.error("FULL ERROR:", error);
      toasted.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      disabled={loading}
      className={`card-feature-btn bookmark-button ${isBookmarked ? "active" : ""}`}
    >
      {isBookmarked ? <Bookmark /> : <BookmarkBorderOutlined />}
    </button>
  );
};

export default Bookmarks;